import { Action, ActionReducer } from '@ngrx/store';
import { EmissionPointIdAction, EmissionPointIdActionType } from '../../actionstypes/selected-id/emission-point-id.actiontype';

const initialState = -1;

const emissionPointIdReducer = (state = initialState, action: EmissionPointIdActionType): number => {
  switch (action.type) {
    case EmissionPointIdAction.Set:
      return action.payload;

    case EmissionPointIdAction.Reset:
      return -1;

    case EmissionPointIdAction.Sync:
      if (state === -1) {
        return state;
      }

      if (!action.payload.includes(state)) {
        return -1;
      }

      return state;

    default:
      return state;
  }
};

export default emissionPointIdReducer as ActionReducer<number, Action<string>>;
